import postAPI from './postAPI.js'

export default async function postSearchCustomers(search) {
    const data = await postAPI('admin/customers/search', { search });
    return data;
}
